import React, { useState, useEffect } from '../node_modules/react';
import Pagination from '../node_modules/rc-pagination';
import {compose, withProps, withHandlers} from '../node_modules/recompose';
import { withScriptjs, withGoogleMap, GoogleMap, Marker} from '../node_modules/react-google-maps';
import { MarkerClusterer } from '../node_modules/react-google-maps/lib/components/addons/MarkerClusterer';
import {toggleMap} from './helepr'

import '../node_modules/rc-pagination/assets/index.css';
import './css/app.css';
import icon from './images/marker.png';
import clusterICon from './images/cluster.svg';

/* Map */
const clusterStyles = [
    {
        textColor: 'black',
        url: clusterICon,
        height: 55,
        width: 55,
        textSize:22
    },
];
const mapStyle = [{ "featureType":"administrative.locality", "elementType":"all", "stylers":[ { "hue":"#2c2e33" }, { "saturation":7 }, { "lightness":19 }, { "visibility":"on" } ] }, { "featureType":"landscape", "elementType":"all", "stylers":[ {"color":"#f5f5f5"}, {"visibility":"simplified"} ] }, { "featureType":"poi", "elementType":"all", "stylers":[ {"hue":"#ffffff"}, {"saturation":-100}, {"lightness":100}, {"visibility":"off"} ] }, { "featureType":"road", "elementType":"geometry", "stylers":[ {"hue":"#bbc0c4"}, {"saturation":-93}, {"lightness":31}, {"visibility":"simplified"} ] }, { "featureType":"road", "elementType":"labels", "stylers":[ {"hue":"#bbc0c4"}, {"saturation":-93}, {"lightness":31}, {"visibility":"on"} ] }, { "featureType":"road.arterial", "elementType":"labels", "stylers":[ {"hue":"#bbc0c4"}, {"saturation":-93}, {"lightness":-2}, {"visibility":"simplified"} ] }, { "featureType":"road.local", "elementType":"geometry", "stylers":[ {"color":"#000"}, {"visibility":"simplified"} ] }, { "featureType":"transit", "elementType":"all", "stylers":[ {"color":"#000"}, {"visibility":"on"} ] }, { "featureType":"water", "elementType":"geometry", "stylers":[ {"color":"#c9c9c9"}, {"lightness":17}, {"visibility":"simplified"} ] } ];

const MapWithAMarkerClusterer = compose(
    withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyD32Uu1F6yXHVPZTjFtD3g8kqd-wNlPfLU&libraries=geometry",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div id="map" style={{ height: `800px` }} />,
        mapElement: <div style={{ height: `100%` }} />,
    }),
    withHandlers(),
    withScriptjs,
    withGoogleMap
)(props =>
    <GoogleMap
        zoom={props.zoom}
        center={props.center}
        options={
            {
                scrollwheel: false,
                minZoom: 3,
                maxZoom: 15,
                styles: mapStyle
            }
        }
    >
        <MarkerClusterer
            onClick={props.onMarkerClustererClick}
            averageCenter
            enableRetinaIcons
            styles={clusterStyles}
            gridSize={60}
        >
            {props.markers.map((marker, key) => (
                <Marker
                    key={key}
                    onClick={(e) => props.onMarkerClick(marker, e)}
                    position={{ lat: marker.latitude, lng: marker.longitude }}
                    icon={icon}
                />
            ))}
        </MarkerClusterer>
    </GoogleMap>
);

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

function App() {
    const [getStations, setStations] = useState([]);
    const [getCurrentPage, setCurrentPage] = useState(1);
    const [getStationsPerPage] = useState(10);
    const [getZoom, setZoom] = useState(8);
    const [getSearchVal, setSearchVal] = useState(() => {
        return sessionStorage.getItem("searchQuery") || "";
    });
    const debouncedSearch = useDebounce(getSearchVal, 500);
    const [getMatchStations, setMatchStations] = useState([]);
    const [getUserCoordinates, setUserCoordinates] = useState({ lat: 59.39387, lng: 15.83882 });
    const [getCenter, setCenter] = useState({ lat: 43.520770, lng: 21.665230 });

    useEffect(() => {
        const getLocationId = () => {
            const el = document.getElementById('stationRoot');
            return el ? el.dataset.locationId : '117';
        }

        fetch(`/api/stations/${getLocationId()}`)
            .then(response => response.json())
            .then(data => [setStations(data), /*setMatchStations(data)*/]);

        // is geolocation supported
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition( (position) => {
                // set center & update user coordinates
                setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                setUserCoordinates({ lat: position.coords.latitude, lng: position.coords.longitude });
                // get stations and sort it by distance
                fetch(`/api/stations/${getLocationId()}`)
                    .then(response => response.json())
                    .then( data => {
                        const t = (data || [])
                            .map( d => {
                                const userCoords = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                                const stationCoords = new google.maps.LatLng(d.latitude, d.longitude);
                                return {
                                    ...d,
                                    distance: google.maps.geometry.spherical.computeDistanceBetween(stationCoords, userCoords)
                                }
                            })
                            .sort(({distance:a}, {distance:b}) => a-b);
                        setStations(t);
                        /*setMatchStations(t);*/
                    })
            });
        }
    }, []);

    useEffect(() => {
        setZoom(7);
        let searchVal = debouncedSearch.toLowerCase();
        let matches = getStations.filter(item => item.name.toLowerCase().includes(searchVal));
        setMatchStations(matches);
        setCurrentPage(1);
        const waitForGoogle = async () => {
            while (!window.google) {
                await new Promise(resolve => setTimeout(resolve, 100)); // Poll every 100ms
            }

            if (debouncedSearch !== "") {
                const bounds = new window.google.maps.LatLngBounds();
                matches.map(place => {
                    bounds.extend({lat: place.latitude, lng: place.longitude});
                    return place.id;
                });
                setTimeout(function () {
                    setCenter({lat: bounds.getCenter().lat(), lng: bounds.getCenter().lng()});
                    setZoom(6);
                }, 500);
            } else {
                setZoom(6);
                setCenter(getUserCoordinates);
            }
        }

        waitForGoogle();
    }, [debouncedSearch, getStations]);

    const onChange = (page) => {
        setCurrentPage(page);
    };

    const indexOfLastTodo = getCurrentPage * getStationsPerPage;
    const indexOfFirstTodo = indexOfLastTodo - getStationsPerPage;
    const currentStations = getMatchStations.slice(indexOfFirstTodo, indexOfLastTodo);

    const getFields = () => {
        const el = document.getElementById('stationRoot');
        const fields = el && el.dataset.fields ? el.dataset.fields : '';
        return fields.split(',');
    }

    const renderStations = currentStations.map((station, index) => {
        if (!station.name.includes('Protatest')) {
            return (
                <div key={index} className="station-box-holder">
                    <div className="d-flex align-items-center station-box">
                        <div className="flex-grow-1 text-black">
                            <a className="text-black" href={station.url}>
                                <h6 className="mb-0 font-azbuka">{station.name}</h6>
                            </a>
                            {
                                getFields().map( key => (
                                    <div className={`mb-0 station-${key}`}
                                         key={`additional_field_${key}`}
                                         dangerouslySetInnerHTML={{ __html: station[key] }} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            );
        }
    });

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(getMatchStations.length / getStationsPerPage); i++) {
        pageNumbers.push(i);
    }
    const total = pageNumbers.length * 10;

    const switchTab = (event) => {
        const selector = event.target.attributes['data-target'].value;

        toggleMap(event, selector);
    };

    /*let typingTimer;
    const keyUp = () => {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, 500);
    };

    const keyDown = () => {
        clearTimeout(typingTimer);
    };

    const doneTyping = () => {
        setSearchVal(input.current.value);
        sessionStorage.setItem("searchQuery", input.current.value);
    };*/

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchVal(value);
        sessionStorage.setItem("searchQuery", value);
    };

    const hideSearch = () => {
        const el = document.getElementById('stationRoot');
        return el ? !el.dataset.showSearch : false;
    }

    const onMarkerClick = (station, e) => {
        if (station && station.url) {
            window.location.replace(station.url);
        }
    }

    return (
        <div className="container">
            <div className="row mb-5 mt-2">
                <div className="col-12">
                    {getStations.length > 0 ? (
                        <div className="row">
                            <div className="col-md-6">
                                {
                                    !hideSearch()
                                        ?
                                        <div>
                                            <div className="form-group">
                                                <input
                                                    /*ref={input}
                                                    onKeyDown={keyDown}
                                                    onKeyUp={keyUp}*/
                                                    value={getSearchVal}
                                                    onChange={handleSearchChange}
                                                    type="text"
                                                    className="form-control station-input"
                                                    placeholder="Skriv stad, stationens namn eller adress" />
                                            </div>
                                            <span className="station-numb">{getStations.length} Stationer</span>
                                        </div>
                                        :
                                        null
                                }

                                <div className="mob-station-nav text-center d-block d-md-none">
                                    <ul className="list-inline d-inline-block">
                                        <li className="list-inline-item active"><a onClick={(event) => switchTab(event)} className="font-azbuka text-uppercase text-dark-gray" data-target="#station" href="#">Lista</a></li>
                                        <li className="list-inline-item"><a onClick={(event) => switchTab(event)} className="font-azbuka text-uppercase text-dark-gray" data-target="#map" href="#">Karta</a></li>
                                    </ul>
                                </div>

                                {getMatchStations.length === 0 ? (
                                    <div className="h-100 align-items-center justify-content-center d-flex">
                                        <h1>Inga stationer funna.</h1>
                                    </div>
                                ) : (
                                    <div id="station" className="station-wrapper mt-0 mt-md-5 d-md-block">
                                        {renderStations}
                                        <div className="pagination text-center">
                                            <Pagination onChange={onChange} showTitle={false} showLessItems current={getCurrentPage} total={total} />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                <MapWithAMarkerClusterer
                                    markers={getMatchStations}
                                    zoom={getZoom}
                                    center={getCenter}
                                    onMarkerClick={onMarkerClick}
                                />
                            </div>
                        </div>
                    ):(
                        <div style={{ height: `400px` }} className="row justify-content-center align-items-center">
                            <div className="col-6 text-center">
                                <h1>Laddar...</h1>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default App;



// WEBPACK FOOTER //
// ./stations/app.js